export default __webpack_public_path__ + "./images/pl.e115a6b3.png";